<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">
        <template v-if="add == true">新增</template>報修單
      </div>
      <div style="margin-top: 2rem">
        <div class="row">
          <template v-if="add == false">
            <basic />
          </template>
          <template v-else-if="add == true">
            <addOrder />
          </template>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import basic from "@/components/deviceManagement/repairOrder/basic.vue";
import addOrder from "@/components/deviceManagement/repairOrder/addOrder.vue";
import { computed, provide, ref } from "vue";
import store from "@/store";
export default {
  components: {
    commonTable,
    basic,
    addOrder,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
    };

    const add = ref(false);

    const currentRepairDeviceTableFields = ref([
      {
        key: "device",
        label: "機台",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "time",
        label: "報修時間",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "description",
        label: "異常描述",
        thStyle: {
          "min-width": "480px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
          "white-space": "pre-line",
        },
      },
      {
        key: "personnel",
        label: "報修人員",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const currentRepairDeviceTableItems = ref([
      // {
      //   device: "鍛造1",
      //   time: "2023-11-10 11:20:00",
      //   description: "入料夾手(Q1)機械異常維修",
      //   personnel: "小明1號",
      // },
      // {
      //   device: "退火3",
      //   time: "2023-11-12 10:47:00",
      //   description: "排煙風機維修",
      //   personnel: "小明2號",
      // },
      // {
      //   device: "環形爐",
      //   time: "2023-11-13 14:35:00",
      //   description: "夾手冷卻水管漏水",
      //   personnel: "小明3號",
      // },
    ]);

    const addRepairOrder = () => {
      add.value = true;
    };
    const checkAdd = (multiInputItems, multiInputVal, textData) => {
      for (let i in multiInputItems) {
        let item = multiInputItems[i];
        if ("checkEmpty" in item && item.checkEmpty == true) {
          if (multiInputVal == undefined) {
            if (item.type == "select") {
              methods.setTimeoutAlert("請選擇" + item.label);
            } else {
              methods.setTimeoutAlert("請輸入" + item.label);
            }
            return;
          }
          if (multiInputVal[item.key] == undefined) {
            if (item.type == "select") {
              methods.setTimeoutAlert("請選擇" + item.label);
            } else {
              methods.setTimeoutAlert("請輸入" + item.label);
            }
            return;
          }
        }
      }
      if (textData == "") {
        methods.setTimeoutAlert("請輸入異常描述");
        return;
      }

      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["oper"] = multiInputVal.oper;
      params["deviceID"] = multiInputVal.deviceID;
      params["textData"] = textData;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "AddCurrentRepairDevice";
      methods.triggerLoadingBar();
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        methods.triggerLoadingBar();
        if (result["Response"] != "ok") {
          methods.setTimeoutAlert(result["Response"]);
        } else {
          cancelAdd();
        }
      });
    };

    const getCurrentRepairDevice = () => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "GET";
      params["whichFunction"] = "GetCurrentRepairDevice";
      methods.triggerLoadingBar();
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] == "ok") {
          currentRepairDeviceTableItems.value = result.QueryTableData;
        } else {
          currentRepairDeviceTableItems.value = [];
          methods.setTimeoutAlert(result["Response"]);
        }
        methods.triggerLoadingBar();
      });
    };
    const cancelAdd = () => {
      getCurrentRepairDevice();
      add.value = false;
    };

    const commonMethods = {
      addRepairOrder: addRepairOrder,
      checkAdd: checkAdd,
      cancelAdd: cancelAdd,
    };

    getCurrentRepairDevice();

    provide("add", add);
    provide("commonMethods", commonMethods);
    provide("currentRepairDeviceTableFields", currentRepairDeviceTableFields);
    provide("currentRepairDeviceTableItems", currentRepairDeviceTableItems);
    return {
      add,
      currentRepairDeviceTableFields,
      currentRepairDeviceTableItems,
      addRepairOrder,
    };
  },
};
</script>

<style></style>
